/**
 * This module handles setting up the table data for exporting to CSV
 * It also includes any special cases previously handled in the DownloadController
 */
define([
  "marionette",
  "backbone",
  "jquery",
  "underscore",
  "moment",
  "messaging/messenger",
  "configuration/properties",
], function (Marionette, Backbone, $, _, Moment, Messenger, Properties) {
  var SortableListDownloadUtilities = {
    parseDataAsCSV: function (
      downloadID,
      tableData,
      tableHeaders,
      firstRecord,
      lastRecord,
      isFiltered,
    ) {
      var csvData = "";
      var records;
      var headers;

      if (isFiltered) {
        records = tableData.filter(function (item) {
          return item.filteredOut === false;
        });
        headers = tableHeaders.filter(function (header) {
          return header.get("hidden") === false;
        });
      } else {
        records = tableData.models;
        headers = tableHeaders.models;
      }

      records = records.slice(firstRecord, lastRecord + 1);

      // Remove any headers that don't have a modelAttribute assigned to it
      headers = headers.filter(function (header) {
        return header.get("modelAttribute") && header.get("modelAttribute") !== "";
      });

      // Add the header labels if this is the first batch
      if (firstRecord === 0) {
        headers.forEach(function (header) {
          csvData += header.get("headerName") + ",";
        });
        // Remove trailing comma
        csvData = csvData.slice(0, -1);
        csvData += "\r\n";
      }

      // Add the table data
      // The tableHeaders collection stores the modelAttribute, so we can use that to fetch the values for each column
      records.forEach(function (data) {
        headers.forEach(function (header) {
          if (
            header.get("modelAttribute") === "dateTime" ||
            header.get("modelAttribute") === "time" ||
            header.get("modelAttribute") === "date" ||
            header.get("dateField")
          ) {
            csvData += _parseDatetime(data.get(header.get("modelAttribute"))) + ",";
          } else {
            csvData += _parseValue(data.get(header.get("modelAttribute"))) + ",";
          }
        });
        csvData = csvData.slice(0, -1);
        csvData += "\r\n";
      });

      return csvData;
    },
    getFilename: function (downloadID, title) {
      var params = Messenger.reqres.request("downloadUrl:" + downloadID);
      var headerParams = Messenger.reqres.request("report:i18nHeaders:" + downloadID);
      var fileName = "";

      switch (downloadID) {
        case "accuracyFMeasure":
        case "accuracyDistribution":
        case "escalation":
        case "categoryReport":
        case "categoryDetailReport":
        case "agentAssistTable":
        case "contentAwarenessMissing":
        case "contentAwarenessModified":
        case "fiscalPerformance":
          // Add the selected date range from the configuration to the title
          var startDate = Messenger.reqres
            .request("get:formatted:date", params["startDate"])
            .replace(/\//g, "-");
          var endDate = Messenger.reqres
            .request("get:formatted:date", params["endDate"])
            .replace(/\//g, "-");
          fileName = title + ", " + startDate + " - " + endDate;
          break;
        case "surveyReport":
        case "downloadLearner":
          fileName = headerParams["downloadableTitle"];
          break;
        default:
          fileName = title;
      }

      return fileName;
    },
    downloadXlsx: function (downloadID, fileName, tableData, tableHeaders) {
      const filteredHeaders = tableHeaders.filter(function (header) {
        return header.get("modelAttribute") && header.get("modelAttribute") !== "";
      });

      var url = _.result(tableData, "downloadUrl") || _.result(tableData, "url");
      if (!url) {
        throw Error("Table data does not have a URL, do not know how to download it");
      }
      if (url.indexOf("?") < 0) {
        url += "?format=xlsx";
      } else {
        url += "&format=xlsx";
      }
      var authorizationHeader = Messenger.reqres.request("authorization:header");
      var headers = {
        "Content-Type": "application/json",
      };
      if (authorizationHeader) {
        headers.Authorization = authorizationHeader;
      }
      const fetchOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          fileName: fileName,
          tableHeaders: filteredHeaders,
        }),
      };
      if (Properties.allowCors) {
        fetchOptions.mode = "cors";
        fetchOptions.credentials = "include";
      } else {
        fetchOptions.mode = "same-origin";
        fetchOptions.credentials = "same-origin";
      }
      // Cannot use jquery ajax to download binary content.
      // Using the Fetch API which should be supported in all modern browsers (no longer care about IE)
      return fetch(url, fetchOptions).then(function (response) {
        if (!response.ok) {
          throw response;
        }
        return response.blob();
      });
    },
  };
  var _parseValue = function (input) {
    if (input === null || input === undefined) {
      return "";
    }
    if (typeof input != "string") {
      input = String(input);
    }
    // Converts any quotes found to double quotes
    var result = input.replace(/"/g, '""');
    // If any commas and newlines are found, then the whole thing gets wrapped in quotes
    if (result.search(/([",\n])/g) >= 0) {
      result = '"' + result + '"';
    }
    return result;
  };
  var _parseDatetime = function (input) {
    // Converts the Unix timestamp to a readable date/time
    var result = Messenger.reqres.request("get:formatted:dateTime:short", input);
    return result;
  };
  return SortableListDownloadUtilities;
});
